//import TabFormsComponent from './TabForms/TabForms'
import FormDetailComponent from './FormDetail/FormDetail'
import FormEditComponent from './FormEdit/FormEdit'
import SectionEditComponent from './SectionEdit/SectionEdit'
import PreviewComponent from './Preview/Preview'
import ModalNewSectionComponent from './ModalNewSection/ModalNewSection'

//export const TabForms = TabFormsComponent
export const FormDetail = FormDetailComponent
export const FormEdit = FormEditComponent
export const SectionEdit = SectionEditComponent
export const Preview = PreviewComponent
export const ModalNewSection = ModalNewSectionComponent
